var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHexagonFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.389 1.276l4.255 2.451a2.117 2.117 0 011.05 1.821v1.57l.017.014v1.753l-.017.013v1.553c0 .753-.402 1.454-1.05 1.822l-4.255 2.451a2.14 2.14 0 01-2.102 0l-4.236-2.451A2.096 2.096 0 012 10.45V5.548c0-.753.403-1.453 1.05-1.82l4.237-2.452a2.14 2.14 0 012.102 0z",
    fill: "url(#HexagonFill_svg__paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HexagonFill_svg__paint0_linear",
    x1: 14.711,
    y1: 15,
    x2: 1.919,
    y2: 14.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F91C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FDBB2"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMzg4NTkgMS4yNzU4TDEzLjY0MzcgMy43MjczMkMxNC4yOTE3IDQuMTEyNTYgMTQuNjk0NCA0Ljc5NTQ5IDE0LjY5NDQgNS41NDg0N1Y3LjExODA3TDE0LjcxMTMgNy4xMzIxNFY4Ljg4NTQyTDE0LjY5NDQgOC44OTgwOVYxMC40NTE1QzE0LjY5NDQgMTEuMjA0NSAxNC4yOTE3IDExLjkwNDkgMTMuNjQzNyAxMi4yNzI3TDkuMzg4NTkgMTQuNzI0MkM4Ljc0MDY5IDE1LjA5MTkgNy45MzUxOCAxNS4wOTE5IDcuMjg3MjggMTQuNzI0MkwzLjA1MDY1IDEyLjI3MjdDMi40MDI3NSAxMS45MDQ5IDIgMTEuMjA0NSAyIDEwLjQ1MTVWNS41NDg0NkMyIDQuNzk1NDkgMi40MDI3NSA0LjA5NTA1IDMuMDUwNjUgMy43MjczMkw3LjI4NzI4IDEuMjc1OEM3LjkzNTE4IDAuOTA4MDY4IDguNzQwNjkgMC45MDgwNjggOS4zODg1OSAxLjI3NThaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSIxNC43MTEzIiB5MT0iMTUiIHgyPSIxLjkxODk2IiB5Mj0iMTQuOTI1NiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMUY5MUMxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzJGREJCMiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgHexagonFill as ReactComponent };